import { Tank } from 'app/agriculture/queries/tanks/types/Tank';
import { useEntities } from 'app/agriculture/queries/entities/useEntities';

export function useTank(tankId: string): Tank {
    const tanks = useEntities('Tank');
    const tank = tanks.get(tankId);

    if (!tank) {
        throw new Error(`No tank found for id: ${tankId}`);
    }

    return tank;
}
